import { render, staticRenderFns } from "./student_view.vue?vue&type=template&id=1f79cd7c&scoped=true&"
import script from "./student_view.vue?vue&type=script&lang=js&"
export * from "./student_view.vue?vue&type=script&lang=js&"
import style0 from "./student_view.vue?vue&type=style&index=0&id=1f79cd7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f79cd7c",
  null
  
)

export default component.exports